var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopilotChatSend = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 19,
  viewBox: "0 0 16 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.286 9.29763C10.3322 9.16751 10.2641 9.02459 10.134 8.97842C10.0039 8.93224 9.86097 9.00028 9.81479 9.1304L7.97563 14.3127L1.10461 13.4809C0.479055 13.4052 0.220073 12.6385 0.671562 12.1989L11.7186 1.44366C12.1614 1.01253 12.9064 1.27197 12.9856 1.88491L14.9569 17.1391C15.0383 17.7688 14.3493 18.2084 13.8126 17.8694L8.44672 14.4802L10.286 9.29763Z",
  stroke: "currentColor",
  strokeWidth: 0.5,
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopilotChatSend);
export { ForwardRef as ReactComponent };